const JWT_STATE = ''

export default JWT_STATE
